import { fetch } from '../utils/fetch'
import { ENDPOINT_PERMS } from '../constants'

const FETCH_PERMS_REQUEST = 'blayzr/perms/REQUEST'
const FETCH_PERMS_SUCCESS = 'blayzr/perms/SUCCESS'
const FETCH_PERMS_FAILURE = 'blayzr/perms/FAIL'

const initialState = {
  data: null,
  fetching: false,
  error: null
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload } = action
  switch (type) {
    case FETCH_PERMS_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case FETCH_PERMS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload.records
      }
    case FETCH_PERMS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    default:
      return state
  }
}

function fetchPermsRequest () {
  return {
    type: FETCH_PERMS_REQUEST
  }
}

function fetchPermsSuccess (data) {
  return {
    type: FETCH_PERMS_SUCCESS,
    payload: data
  }
}

function fetchPermsFailure (error) {
  return {
    type: FETCH_PERMS_FAILURE,
    payload: { error }
  }
}

export function fetchPerms () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token
    }
    dispatch(fetchPermsRequest())
    fetch(ENDPOINT_PERMS, options, dispatch).then(data => {
      dispatch(fetchPermsSuccess(data))
    }, e => {
      dispatch(fetchPermsFailure(e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/perms.js